export const MOBILE_SUGGESTIONS = [
  {
    imgUrl:
      'https://res.cloudinary.com/djxk74uhg/image/fetch/f_auto/https://cdn.routeperfect.com/app/images/homepageBodyImages/topItineraries/paris.jpg?_a=ATFGlRg0',
    label: 'Paris',
  },
  {
    imgUrl:
      'https://res.cloudinary.com/djxk74uhg/image/fetch/f_auto/https://cdn.routeperfect.com/app/images/homepageBodyImages/topItineraries/London.jpg?_a=ATFGlRg0',
    label: 'London',
  },
  {
    imgUrl:
      'https://res.cloudinary.com/djxk74uhg/image/fetch/f_auto/https://cdn.routeperfect.com/images/itinerary/0/822c4558372dd1028629212b8e062645_1710859220.jpg?_a=ATFGlRg0',
    label: 'Rome',
  },
];

export const DESKTOP_SUGGESTIONS = [
  ...MOBILE_SUGGESTIONS,
  {
    imgUrl:
      'https://res.cloudinary.com/djxk74uhg/image/fetch/f_auto/https://cdn.routeperfect.com/app/images/homepageBodyImages/topItineraries/japan.jpg?_a=ATFGlRg0',
    label: 'Tokyo',
  },
];
